import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./SmallRpcCourse.css";
import EnrollForm from "./EnrollForm";

const CertificateEnrollTemplate = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL+`/api/certificates/${id}`)
      .then((res) => res.json())
      .then((data) => setCourse(data))
      .catch((err) => console.error(err));
  }, [id]);

  if (!course) return <h2 style={{ textAlign: "center" }}>Loading...</h2>;

  return (
    <div className="course-page">

      {/* Top Section */}
      <div className="course-container">
        <div className="course-text">
          <h2>{course.name}</h2>
          <p>{course.description}</p>

          <div className="btn-group">
            <span className="price">₹{course.price}</span>
            <button className="enroll" onClick={() => setShowForm(true)}>
              ENROLL NOW
            </button>
          </div>

          <div className="info-section">
            <div className="info-card">
              <span>⏱</span>
              <p><b>DURATION</b><br />{course.days} Days</p>
            </div>
            <div className="info-card">
              <span>💰</span>
              <p><b>GST</b><br />{course.gst}</p>
            </div>
            <div className="info-card">
              <span>📍</span>
              <p><b>LOCATION</b><br />{course.location || "Manikampalayam, Namakal"}</p>
            </div>
          </div>
        </div>

        <div className="course-image">
          <img
            src={course.image ? process.env.REACT_APP_API_URL+`${course.image}` : '/placeholder.png'}
            alt={course.name}
          />
        </div>
      </div>

      {/* Details Section */}
      <div className="course-details">
        <h3>About the Course</h3>
        <p>{course.aboutCourse}</p>

        <h3>Eligibility</h3>
        <ul>
          {(Array.isArray(course.eligibility)
            ? course.eligibility
            : course.eligibility?.split(',') || []
          ).map((item, i) => (
            <li key={i}>{item.trim()}</li>
          ))}
        </ul>

        <h3>This Course Includes</h3>
        <ul>
          {(Array.isArray(course.courseIncludes)
            ? course.courseIncludes
            : course.courseIncludes?.split(',') || []
          ).map((item, i) => (
            <li key={i}>{item.trim()}</li>
          ))}
        </ul>

        <h3>This Course Excludes</h3>
        <ul>
          {(Array.isArray(course.courseExcludes)
            ? course.courseExcludes
            : course.courseExcludes?.split(',') || []
          ).map((item, i) => (
            <li key={i}>{item.trim()}</li>
          ))}
        </ul>
      </div>

      {/* Enroll Form Popup */}
      {showForm && (
  <EnrollForm
    course={course}   // pass full course object instead of course.name
    onClose={() => setShowForm(false)}
  />
)}

    </div>
  );
};

export default CertificateEnrollTemplate;
